let Domain = Object.freeze({
  live: "https://portal.edpass.co/" + localStorage.port + "/api/v1/",
  main: "https://admin.edpass.co/service/",
  base: "https://portal.edpass.co/" + localStorage.port,
  raw: "https://portal.edpass.co/"
});

export const apiDomain = Domain.live;
export const mainDomain = Domain.main;
export const baseDomain = Domain.base;
export const rawDomain = Domain.raw;

export default {
  MAIN_DOMAIN: mainDomain,
  APP_DOMAIN: apiDomain,
  BASE_DOMAIN: baseDomain,
  RAW_DOMAIN: rawDomain,
  get APP_HEADER() {
    const AuthStr = "Bearer ".concat(localStorage.token);
    return {
      headers: {
        Authorization: AuthStr
      }
    };
  },
  get APP_HEADER_FORM_DATA() {
    const AuthStr = "Bearer ".concat(localStorage.token);
    return {
      headers: {
        Authorization: AuthStr,
        "Content-Type": "multipart/form-data"
      }
    };
  }
};
